import { NeoState } from '../Reducers.interface';

export const selectSessionData = (key: string) => (state: NeoState) => state.app.session[key];
